import { Box, Button, Stack, TextField } from "@mui/material";
import { FormEvent, useState } from "react";
import { useGetMe, useUpdateMe } from "../hooks";

export const UpdateBankCredentialsModal = () => {
  const { me } = useGetMe();
  const { updateMe, isUpdateMeLoading } = useUpdateMe();

  const [bankCredentials, setBankCredentials] = useState(
    me?.bankAccountCredentials || ""
  );

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    updateMe({ bankAccountCredentials: bankCredentials });
  };

  return (
    <Box
      component={"form"}
      onSubmit={onSubmit}
      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
    >
      <TextField
        multiline
        required
        variant="outlined"
        placeholder="Bank account credentials"
        minRows={5}
        slotProps={{ htmlInput: { maxLength: 500 } }}
        value={bankCredentials}
        onChange={({ currentTarget: { value } }) => setBankCredentials(value)}
      />
      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Button type="button" disabled={isUpdateMeLoading}>
          Cancel
        </Button>
        <Button
          type="submit"
          loading={isUpdateMeLoading}
          color="success"
          disabled={!bankCredentials.length || isUpdateMeLoading}
        >
          Update
        </Button>
      </Stack>
    </Box>
  );
};
